import React, { useCallback, useEffect, useState } from "react";
import { SdaControlled, SdaDetails } from "./sda-controlled";

interface SdaUncontrolledProps {
  sdaAccessor: () => Promise<SdaDetails | undefined>;
  onViewDetailsClick: () => void;
  onChangeClick: () => void;
  onSupportLinkClick: () => void;
}

export const SdaUncontrolled = ({
  sdaAccessor,
  onViewDetailsClick,
  onChangeClick,
  onSupportLinkClick,
}: SdaUncontrolledProps) => {
  const [sdaDetails, setSdaDetails] = useState<SdaDetails | undefined>();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<boolean>(false);

  const requestSda = useCallback(async () => {
    setLoading(true);
    try {
      const sdaDetails = await sdaAccessor();

      if (sdaDetails?.errorCode) {
        setError(true);
      } else {
        setSdaDetails(sdaDetails);
        setError(false);
      }
    } catch (e) {
      setError(true);
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    requestSda();
  }, []);

  return (
    <SdaControlled
      details={sdaDetails}
      onRetry={requestSda}
      onViewDetailsClick={onViewDetailsClick}
      onChangeClick={onChangeClick}
      onSupportLinkClick={onSupportLinkClick}
      loading={loading}
      error={error}
    />
  );
};
